import { UserStore } from '@intelingu/core/stores/UserStore';
import { IsDefined, IsEmail, IsNotEmpty, IsNumber, MinLength } from 'class-validator';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Trans } from 'react-i18next';
import { Link, Redirect, RouteComponentProps } from 'react-router-dom';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { UserApi } from '@intelingu/core/api/UserApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { IsEqualTo } from '@intelingu/core/validators/decorators/IsEqualTo';
import { lazyInject } from '@intelingu/core/IoC/container';
import { CourseStore } from '@intelingu/core/stores/CourseStore';
import Logger from '@intelingu/core/utils/Logger';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { CoursesSelect } from '../../../partials/CoursesSelect';
import { SubmitButton } from '../../../partials/form/elements/SubmitButton';
import { TextInput } from '../../../partials/form/elements/TextInput';
import { Field } from '@intelingu/core/components/form/Field';
import { Form } from '@intelingu/core/components/form/Form';
import {SocialButtons} from "../../../partials/SocialButtons";
import {AuthStore} from "../../../../stores/AuthStore";

export interface RegisterPageProps extends RouteComponentProps<any> {
    t?;
}

class RegisterRequest {

    @IsEmail()
    email: string;

    @IsNumber()
    course: number;

    @IsNotEmpty()
    first_name: string;

    @IsNotEmpty()
    last_name: string;

    @MinLength(6)
    password: string;

    @IsEqualTo('password', {
        message: 'passwords are not equal'
    })
    password_repeat: string;

}

@withTranslation(COMMON_NS)
@observer export class RegisterPage extends Component<RegisterPageProps, any> {

    @lazyInject(UserApi) userApi: UserApi;
    @lazyInject(CourseStore) courseStore: CourseStore;
    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(AuthStore) authStore: AuthStore;

    @observable isError = false;

    @action.bound async register(data, done) {
        try {
            const response = await this.userApi.register({ ...data, web_account: true });
            const { token } = response.data;

            await this.authStore.authorizeWithToken(token);
        } catch (e) {
            this.isError = true;

            Logger.error(e);
        } finally {
            done();
        }
    }

    componentDidMount(): void {
        this.courseStore.loadCoursesList(true);
    }

    render() {
        const { t } = this.props;

        if (this.userStore.user) {
            return <Redirect to={`/`} />
        }

        return <div className={'session-page'}>
            <h1>{ t('sessionRegisterWithTitle') }:</h1>

            <div className={'sep'} />

            <SocialButtons />

            <div className={'or'}>
                <span>{ t('sessionOr') }</span>
            </div>

            <Form validator={RegisterRequest} onSubmit={this.register}>
                <FormGroup>
                    <Label for="email">{ t('sessionEmail') }</Label>

                    <Field
                        name={'email'}
                        render={props => <TextInput type={'email'} {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="course">{ t('registerTrialCourse') }</Label>

                    <Field
                        name={'course'}
                        render={props => {
                            return <CoursesSelect
                                addOther={true}
                                defaultValue={props.value}
                                onChange={props.onChange}/>
                        }}
                    />
                </FormGroup>

                {/*<FormGroup>
                    <Label for="first_name">First name</Label>

                    <Field
                        name={'first_name'}
                        render={props => <TextInput {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="last_name">Last name</Label>

                    <Field
                        name={'last_name'}
                        render={props => <TextInput {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="password">Password</Label>

                    <Field
                        name={'password'}
                        render={props => <TextInput type={'password'} {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="password">Repeat password</Label>

                    <Field
                        name={'password_repeat'}
                        render={props => <TextInput type={'password'} {...props} />}
                    />
                </FormGroup>*/}

                <FormGroup>
                    <Label for="first_name">{ t('profileFormFirstName') }</Label>

                    <Field
                        name={'first_name'}
                        render={props => <TextInput {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="last_name">{ t('profileFormLastName') }</Label>

                    <Field
                        name={'last_name'}
                        render={props => <TextInput {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="password">{ t('sessionPassword') }</Label>

                    <Field
                        name={'password'}
                        render={props => <TextInput type={'password'} {...props} />}
                    />
                </FormGroup>

                <FormGroup>
                    <Label for="password">{ t('sessionRepeatPassword') }</Label>

                    <Field
                        name={'password_repeat'}
                        render={props => <TextInput type={'password'} {...props} />}
                    />
                </FormGroup>

                { this.isError && (
                    <div className="alert alert-danger" style={{ display: 'block' }}>{ t('sessionEmailAlreadyUsed') }</div>
                )}

                <FormGroup style={{ marginTop: 20 }}>
                    <Field submit render={props => <SubmitButton className={'outline'} {...props}>{ t('sessionRegisterButton') }</SubmitButton>} />
                </FormGroup>
            </Form>

            <div className={'bottom-links solid'}>
                <Trans
                    defaults={t('sessionAlreadyHasAccount')}
                    components={[<Link to={`/session/login`}>Log in</Link>]}
                />

                {/*Already an Intelingu user? <Link to={`/session/login`}>Log in</Link> here.*/}
            </div>
        </div>
    }

}
